import { HttpStatus } from '@montugroup/apis-styleguide';
import { getOrderReceipt } from '@montugroup/circuit-api-contracts';
import { getTsAdminClient } from '@montugroup/circuit-shared/api/admin.client';
import { useQuery } from '@tanstack/react-query';
import { TsRestResponseError } from '@ts-rest/core';

const client = getTsAdminClient();

export function useGetOrderReceipt({ orderId }: { orderId: number | null }) {
  return useQuery({
    queryKey: ['order', 'receipt', orderId],
    enabled: !!orderId,
    queryFn: async () => {
      if (!orderId) {
        return;
      }
      const res = await client.getOrderReceipt.query({ params: { orderId } });
      if (res.status !== HttpStatus.OK) {
        throw new TsRestResponseError(getOrderReceipt, res);
      }
      return res.body.data;
    },
    meta: {
      error: {
        message: 'Unable to download payment receipt',
        showToast: true,
      },
    },
  });
}
